import { IGetListParams } from './../../../base/base.service';
import { TasksService, ITask } from "../../../services";

class DashboardTasksController {
    private tasks: ITask[];
    constructor(private TasksService: TasksService) {
        "ngInject";
    }

    public $onInit = () => {
        this.getTasks();
    }

    public getTasks = () => {
        const params: IGetListParams = {
            limit: 10,
            sortfield: 'createdOn',
            sortorder: 'desc'
        }
        this.TasksService.all(params).then((tasks) => {
            this.tasks = tasks;
        })
    }
}

export const dashboardTasksComponent = {
    controller: DashboardTasksController,
    template: require('./dashboardTasks.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/tasks/dashboardTasks.component.ts